module.exports = __webpack_public_path__ + "img/logo.a0e599b9.png";